import React from 'react'
import { FormikStepProps } from '../../../components/form/wizzard/FormikStepper'
import { AdGroupCreateInput, useCompanyPermissionsQuery } from '../../../__generated__/graphql'
import { EditionModeContextProvider, EditionModes } from '../../../utils/providers/editionModeContext'
import { useCompanyDetailsContext } from '../../../utils/hooks/useCompanyDetailsContext'
import { BudgetAndDates } from '../settings/budgetAndDates'
import { toAdgroupBudgetPermissions } from '../settings/budgetAndDates/adgroupBudgetPermissions.utils'

const AdgroupBudgetStep: React.FC<FormikStepProps & { adgroup: AdGroupCreateInput }> = ({ adgroup }) => {
  const {
    company: { slug },
  } = useCompanyDetailsContext()
  const { data: companyPermissions } = useCompanyPermissionsQuery({ variables: { slug } })
  const advertiserBudgetPermissions = companyPermissions?.company.permissions
    ? toAdgroupBudgetPermissions(companyPermissions.company.permissions)
    : undefined

  return (
    <EditionModeContextProvider defaultMode={EditionModes.Edition}>
      <BudgetAndDates
        adgroup={adgroup}
        isWizard
        canEdit
        showSectionTitle={false}
        fullWidth
        budgetPermissions={advertiserBudgetPermissions}
      />
    </EditionModeContextProvider>
  )
}

export default AdgroupBudgetStep
